import React from 'react';
import { useTranslation } from 'react-i18next';

function Agents() {
  const { t } = useTranslation();
  
  const agents = [
    {
      name: t('agents.athena.name'),
      title: t('agents.athena.title'),
      description: t('agents.athena.description')
    },
    {
      name: t('agents.hector.name'),
      title: t('agents.hector.title'),
      description: t('agents.hector.description')
    },
    {
      name: t('agents.theseus.name'),
      title: t('agents.theseus.title'),
      description: t('agents.theseus.description')
    },
    {
      name: t('agents.deadalus.name'),
      title: t('agents.deadalus.title'),
      description: t('agents.deadalus.description')
    }
  ];

  return (
    <section className="section agents-section" id="agents">
      <div className="container">
        <span className="section-label">{t('agents.label')}</span>
        <h2 className="section-title">{t('agents.title')}</h2>
        <p className="section-subtitle">{t('agents.subtitle1')}<span class="agents-subtitle-atlas">A T L A S</span>{t('agents.subtitle2')}</p>

        <div className="agents-grid">
          {agents.map((agent) => (
            <div className="agent-card animate-on-scroll" key={agent.name}>
              <div className="agent-header">
                <span className="agent-name">{agent.name}</span>
                <span className="agent-dash">—</span>
                <span className="agent-title">{agent.title}</span>
              </div>
              <p className="agent-description">{agent.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Agents;
